import * as VueGoogleMaps from "vue2-google-maps";
import Vue from "vue";

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDQfr3V_JHN9CuguMFBCYV8ZLd7xEC4B-U",
        libraries: 'places',
    },
    installComponents: true,
});